export default {
  auto: 'Automatyczny',
  signals: 'Sygnały',
  axes: 'Siekiery',
  axesHeader: {
    displayName: 'Etykieta osi',
    chartScaleType: 'Typ osi',
    position: 'Pozycja osi',
    limitMin: 'Limit minimalny',
    limitMax: 'Maksymalny limit',
    defaultUnitOfMeasure: 'Jednostka miary',
    signalCount: 'Liczba sygnałów',
    delete: '',
  },
  deleteAxisConfirmation: {
    title: 'Usunąć oś?',
    message: 'Sygnały tej osi ({count}) również zostaną usunięte z wykresu.',
  },
};
